import React, { PropTypes } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

// eslint-disable-next-line css-modules/no-unused-class
import s from './Collapsible.scss';

class Collapsible extends React.Component {
  static defaultProps = {
    open: false,
    headingWhenOpened: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: this.props.open,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    return (
      <div className={cx('panel', s.panel)}>
        <div className={cx('panel-heading', s.panelHeading)}>
          <Button
            className={cx('btn', s.toggleButton)}
            onClick={() => this.toggle()}
          >
            {this.state.open && this.props.headingWhenOpened
              ? this.props.headingWhenOpened
              : this.props.heading}
            <i
              className={
                this.state.open ? 'fa fa-caret-up' : 'fa fa-caret-down'
              }
            />
          </Button>
        </div>
        <div className={cx('panel-body', s.panelBody)}>
          <Collapse in={this.state.open}>
            {this.props.children}
          </Collapse>
        </div>
      </div>
    );
  }
}

Collapsible.propTypes = {
  open: PropTypes.bool,
  heading: PropTypes.string.isRequired,
  headingWhenOpened: PropTypes.string,
  children: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(s)(Collapsible);



// WEBPACK FOOTER //
// ./src/components/Collapsible/index.js